import http from '../common/compornents/httpcommon';

class ColorServ {
  getCatalogData = () => {
    return http.get('getCatalogData/');
  };

  getColorData = (params: any) => {
    return http.get('getColorData/', { params });
  };
}

export default new ColorServ();
